<!-- 新闻详情页 -->
<template>
  <div class="newpage">
    <div class="main">
      <div class="kong">
        <Header></Header>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <router-link class="no" to="/">{{
                $t("system.contact.register.s_y")
              }}</router-link>
              <text>></text>
              <router-link class="no" to="/news/new">{{
                $t("system.map.news")
              }}</router-link>
              <text>></text>
              <a class="th">{{
                $i18n.locale === "zh-cn" ? newsDetail.title : newsDetail.titleEn
              }}</a>
            </div>
          </div>
        </div>
        <div class="news-container">
          <div class="news-main">
            <div class="content" v-if="$i18n.locale === 'zh-cn'">
              <h1>{{ newsDetail.title }}</h1>
              <div class="news-date">
                {{ newsDetail.createTime?.split(" ")[0] }}
              </div>
              <img
                :src="newsDetail.img"
                alt="news image"
                v-if="newsDetail.img"
              />
              <div v-html="newsDetail.content"></div>

              <!-- 添加导航 -->
              <div class="news-navigation">
                <div
                  class="nav-item prev"
                  v-if="getPrevNews"
                  @click="handleNewsClick(getPrevNews.id)"
                >
                  <span class="nav-label">上一篇</span>
                  <span class="nav-title">{{ getPrevNews.title }}</span>
                </div>
                <div
                  class="nav-item next"
                  v-if="getNextNews"
                  @click="handleNewsClick(getNextNews.id)"
                >
                  <span class="nav-label">下一篇</span>
                  <span class="nav-title">{{ getNextNews.title }}</span>
                </div>
              </div>
            </div>
            <!-- 英文 -->
            <div class="content" v-if="$i18n.locale === 'en'">
              <h1>{{ newsDetail.titleEn }}</h1>
              <div class="news-date">
                {{ newsDetail.createTime?.split(" ")[0] }}
              </div>
              <img
                :src="newsDetail.img"
                alt="news image"
                v-if="newsDetail.img"
              />
              <div v-html="newsDetail.contentEn"></div>
              <div class="news-navigation">
                <div
                  class="nav-item prev"
                  v-if="getPrevNews"
                  @click="handleNewsClick(getPrevNews.id)"
                >
                  <span class="nav-label">Previous</span>
                  <span class="nav-title">{{ getPrevNews.titleEn }}</span>
                </div>
                <div
                  class="nav-item next"
                  v-if="getNextNews"
                  @click="handleNewsClick(getNextNews.id)"
                >
                  <span class="nav-label">Next</span>
                  <span class="nav-title">{{ getNextNews.titleEn }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="news-sidebar">
            <div class="latest-news">
              <h3 class="sidebar-title">
                <span class="title-text">{{
                  $t("system.map.latestNews")
                }}</span>
              </h3>
              <ul class="news-list">
                <li
                  v-for="news in sidebarNews"
                  :key="news.id"
                  @click="handleNewsClick(news.id)"
                >
                  <div class="news-item">
                    <span class="news-title"
                      >-{{
                        $i18n.locale === "zh-cn" ? news.title : news.titleEn
                      }}</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "./../../utils/axios.js";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
const getNewsDetail = (id) => {
  return axios.get(`framework/news/info/${id}`);
};
const route = useRoute();
const router = useRouter(); // 初始化 router
const newsDetail = ref({});
// 获取新闻详细数据
const fetchNewsDetail = async (id: string) => {
  try {
    const response = await getNewsDetail(id);
    newsDetail.value = response;
  } catch (error) {
    console.error("获取新闻详情失败：", error.message);
  }
};
// 组件挂载时调用fetchNewsDetail方法获取新闻详情
onMounted(async () => {
  const newsId = route.params.id;
  if (newsId) {
    await getLatestNews(); // 先获取新闻列表
    await fetchNewsDetail(newsId); // 再获取新闻详情
  }
});
watch(
  () => route.params.id,
  async (newId) => {
    if (newId) {
      await getLatestNews(); // 先获取新闻列表
      await fetchNewsDetail(newId); // 再获取新闻详情
      window.scrollTo(0, 0);
    }
  }
);
// 添加最新新闻列表数据
const latestNews = ref([]);

// 获取最新新闻列表
const getLatestNews = async () => {
  try {
    const response = await axios.get("/framework/news/list", {
      params: {
        pageSize: 100,
        num: 1,
      },
    });
    latestNews.value = response.records;
  } catch (error) {
    console.error("获取最新新闻失败：", error);
  }
};

// 处理新闻点击
const handleNewsClick = (id: number) => {
  router.push({
    path: `/news/newpage/${id}`,
  });
};
const sidebarNews = computed(() => {
  return latestNews.value.slice(0, 6); // 只显示前6条
});

// 获取当前新闻在列表中的索引
const getCurrentIndex = computed(() => {
  const currentId = route.params.id;
  const index = latestNews.value.findIndex((news) => news.id === currentId);
  return index;
});

// 获取上一篇新闻
const getPrevNews = computed(() => {
  const currentIndex = getCurrentIndex.value;
  // 上一篇就是列表中的前一条
  return currentIndex > 0 ? latestNews.value[currentIndex - 1] : null;
});

// 获取下一篇新闻
const getNextNews = computed(() => {
  const currentIndex = getCurrentIndex.value;
  // 下一篇就是列表中的后一条
  return currentIndex < latestNews.value.length - 1
    ? latestNews.value[currentIndex + 1]
    : null;
});
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.wrap {
  width: 100%;
  height: auto;
  overflow: visible; /* 添加overflow visible */
}

.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 86px;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.main {
  width: 100%;
  height: auto;
  overflow: visible; /* 修改overflow为visible */
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}

.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}

.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}

.content {
  margin-top: 30px;
}
.content {
  width: 100%;
  margin: 0;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
}
h1 {
  list-style: none;
  white-space: pre-wrap;  
  word-wrap: break-word; 
  overflow-wrap: break-word; 
  line-height: 1.2; 
}
.content :deep(img) {
  display: block;
  max-width: 800px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.content :deep(div) {
  text-align: justify;
  font-size: 18px;
  line-height: 2.0; 
  /* margin-bottom: 25px; */
  color: #666;
}

.content p {
  text-align: justify;
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 20px;
  color: #666;
}

.content img {
  display: block;
  width: 25%;
  max-width: 400px;
  height: auto;
  /* margin: 20px auto; */
  margin-bottom: 20px;
  border-radius: 10px;
  transition: transform 0.2s;
}

.content img:hover {
  transform: scale(1.05);
}
.news-path {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.news-date {
  color: #999;
  font-size: 14px;
  margin: -10px 0 30px;
}

.content h1 {
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 20px;
  color: #333;
  padding-bottom: 10px;
}
.news-container {
  display: flex;
  max-width: 1230px;
  margin: 0 auto;
  gap: 30px;
}

.news-main {
  flex: 1;
  max-width: calc(100% - 330px); /* 300px侧边栏 + 30px间距 */
}

.news-sidebar {
  width: 300px;
  margin-top: 30px;
  flex-shrink: 0; /* 防止侧边栏被压缩 */
  position: sticky;
  top: 120px; /* 调整固定位置，避免被header遮挡 */
  align-self: flex-start; /* 确保在flex容器中正确定位 */
  height: fit-content; /* 高度适应内容 */
}

.latest-news {
  background: #fff;
  border-radius: 0;
}

.sidebar-title {
  position: relative;
  background: #03126b;
  padding: 5px 15px;
  margin: 0;
  clip-path: polygon(0 0, 95% 0, 100% 100%, 0 100%);
}

.title-text {
  color: #fff;
  font-size: 18px;
  font-weight: normal;
  position: relative;
  padding-left: 0;
  display: block;
  width: 95%;
}

.news-list {
  list-style: none;
  padding: 15px 20px;
  margin: 0;
}

.news-list li {
  padding: 8px 0;
  cursor: pointer;
}

.news-item {
  position: relative;
  padding-left: 12px;
}

.news-title {
  color: #666;
  font-size: 14px;
  line-height: 1.8;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-list li:hover .news-title {
  color: #004080;
}

.news-navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.nav-item {
  cursor: pointer;
  max-width: 45%;
  transition: all 0.3s ease;
}

.nav-item:hover {
  color: #004080;
}

.nav-label {
  display: block;
  font-size: 14px;
  color: #999;
  margin-bottom: 5px;
}

.nav-title {
  display: block;
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    color: #004080;
  }
}

.prev {
  text-align: left;
}

.next {
  text-align: right;
}
</style>
